import { Inject } from 'inversify-props';
import { CodigoEDescricao } from '@/models/shareds/CodigoEDescricao';
import { Page } from '@/models';
import type { ServiceIBSAdapter } from '../adapter';

export class FindIBSUseCase {
	@Inject("ServiceIBSAdapter")
	private ibsService!: ServiceIBSAdapter

	findById = async (id: string): Promise<CodigoEDescricao> =>
		await this.ibsService.get(id)

	find = async (params?: any): Promise<Page<CodigoEDescricao>> =>
		await this.ibsService.find(params);

}